import types from "./types";

const InitialState = {
  organizationList: [],
  isFetchingOrganizations: false,
  organizationsError: "",

  regionList: [],
  isFetchingRegions: false,
  regionsError: "",

  municipalList: [],
  isFetchingMunicipals: false,
  municipalsError: "",

  wsCategoryList: [],
  isFetchingWsCategories: false,
  wsCategoriesError: "",

  targetGroupList: [],
  isFetchingTargetGroups: false,
  targetGroupError: "",

  trialFormList: [],
  isFetchingTrialForms: false,
  trialFormError: "",

  eduFormList: [],
  isFetchingEduForms: false,
  eduFormError: "",

  legalFormList: [],
  isFetchingLegalForms: false,
  legalFormError: "",

  groupTypeList: [],
  isFetchingGroupType: false,
  groupTypeError: "",

  skillList: [],
  isFetchingSkills: false,
  skillsError: "",

  moduleList: [],
  isFetchingModules: false,
  modulesError: "",

  personPostList: [],
  isFetchingPersonPost: false,
  personPostListError: "",
}

export default (
  state = InitialState,
  action
) => {
  switch (action.type) {
    case types.DICT_ALL_ORGANIZATION_REQUEST:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
      }
    case types.DICT_ALL_ORGANIZATION_COMPLETE:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizationList: action.organizationList
      }
    case types.DICT_ALL_ORGANIZATION_ERROR:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizationsError: action.organizationsError
      }

    case types.DICT_ALL_REGION_REQUEST:
      return {
        ...state,
        isFetchingRegions: action.isFetchingRegions,
      }
    case types.DICT_ALL_REGION_COMPLETE:
      return {
        ...state,
        isFetchingRegions: action.isFetchingRegions,
        regionList: action.regionList
      }
    case types.DICT_ALL_REGION_ERROR:
      return {
        ...state,
        isFetchingRegions: action.isFetchingRegions,
        regionsError: action.regionsError
      }

    case types.DICT_ALL_MUNICIPAL_REQUEST:
      return {
        ...state,
        isFetchingMunicipals: action.isFetchingMunicipals,
      }
    case types.DICT_ALL_MUNICIPAL_COMPLETE:
      return {
        ...state,
        isFetchingMunicipals: action.isFetchingMunicipals,
        municipalList: action.municipalList
      }
    case types.DICT_ALL_MUNICIPAL_ERROR:
      return {
        ...state,
        isFetchingMunicipals: action.isFetchingMunicipals,
        municipalsError: action.municipalsError
      }

    case types.DICT_ALL_TRIAL_FORM_REQUEST:
      return {
        ...state,
        isFetchingTrialForms: action.isFetchingTrialForms,
      }
    case types.DICT_ALL_TRIAL_FORM_COMPLETE:
      return {
        ...state,
        isFetchingTrialForms: action.isFetchingTrialForms,
        trialFormList: action.trialFormList
      }
    case types.DICT_ALL_TRIAL_FORM_ERROR:
      return {
        ...state,
        isFetchingTrialForms: action.isFetchingTrialForms,
        trialFormError: action.trialFormError
      }

    case types.DICT_ALL_EDU_FORM_REQUEST:
      return {
        ...state,
        isFetchingEduForms: action.isFetchingEduForms,
      }
    case types.DICT_ALL_EDU_FORM_COMPLETE:
      return {
        ...state,
        isFetchingEduForms: action.isFetchingEduForms,
        eduFormList: action.eduFormList
      }
    case types.DICT_ALL_EDU_FORM_ERROR:
      return {
        ...state,
        isFetchingEduForms: action.isFetchingEduForms,
        eduFormError: action.eduFormError
      }

    case types.DICT_ORG_LEGAL_FORM_REQUEST:
      return {
        ...state,
        isFetchingLegalForms: action.isFetchingLegalForms,
      }
    case types.DICT_ORG_LEGAL_FORM_COMPLETE:
      return {
        ...state,
        isFetchingLegalForms: action.isFetchingLegalForms,
        legalFormList: action.legalFormList
      }
    case types.DICT_ORG_LEGAL_FORM_ERROR:
      return {
        ...state,
        isFetchingLegalForms: action.isFetchingLegalForms,
        legalFormError: action.legalFormError
      }

    case types.DICT_ALL_TARGET_GROUP_REQUEST:
      return {
        ...state,
        isFetchingTargetGroups: action.isFetchingTargetGroups,
      }
    case types.DICT_ALL_TARGET_GROUP_COMPLETE:
      return {
        ...state,
        isFetchingTargetGroups: action.isFetchingTargetGroups,
        targetGroupList: action.targetGroupList
      }
    case types.DICT_ALL_TARGET_GROUP_ERROR:
      return {
        ...state,
        isFetchingTargetGroups: action.isFetchingTargetGroups,
        targetGroupError: action.targetGroupError
      }

    case types.DICT_ALL_WS_CATEGORY_REQUEST:
      return {
        ...state,
        isFetchingWsCategories: action.isFetchingWsCategories,
      }
    case types.DICT_ALL_WS_CATEGORY_COMPLETE:
      return {
        ...state,
        isFetchingWsCategories: action.isFetchingWsCategories,
        wsCategoryList: action.wsCategoryList
      }
    case types.DICT_ALL_WS_CATEGORY_ERROR:
      return {
        ...state,
        isFetchingWsCategories: action.isFetchingWsCategories,
        wsCategoriesError: action.wsCategoriesError
      }

    case types.DICT_ALL_SKILLS_REQUEST:
      return {
        ...state,
        isFetchingSkills: action.isFetchingSkills,
      }
    case types.DICT_ALL_SKILLS_COMPLETE:
      return {
        ...state,
        isFetchingSkills: action.isFetchingSkills,
        skillList: action.skillList
      }
    case types.DICT_ALL_SKILLS_ERROR:
      return {
        ...state,
        isFetchingSkills: action.isFetchingSkills,
        skillsError: action.skillsError
      }

    case types.DICT_ALL_MODULES_REQUEST:
      return {
        ...state,
        isFetchingModules: action.isFetchingModules,
      }
    case types.DICT_ALL_MODULES_COMPLETE:
      return {
        ...state,
        isFetchingModules: action.isFetchingModules,
        moduleList: action.moduleList
      }
    case types.DICT_ALL_MODULES_ERROR:
      return {
        ...state,
        isFetchingModules: action.isFetchingModules,
        modulesError: action.modulesError
      }

    case types.DICT_GROUP_TYPES_REQUEST:
      return {
        ...state,
        isFetchingGroupType: action.isFetchingGroupType,
      }
    case types.DICT_GROUP_TYPES_COMPLETE:
      return {
        ...state,
        isFetchingGroupType: action.isFetchingGroupType,
        groupTypeList: action.groupTypeList
      }
    case types.DICT_GROUP_TYPES_ERROR:
      return {
        ...state,
        isFetchingGroupType: action.isFetchingGroupType,
        groupTypeError: action.groupTypeError
      }

    case types.DICT_PERSON_POST_REQUEST:
      return {
        ...state,
        isFetchingPersonPost: action.isFetchingPersonPost,
      }
    case types.DICT_PERSON_POST_COMPLETE:
      return {
        ...state,
        isFetchingPersonPost: action.isFetchingPersonPost,
        personPostList: action.personPostList
      }
    case types.DICT_PERSON_POST_ERROR:
      return {
        ...state,
        isFetchingPersonPost: action.isFetchingPersonPost,
        personPostListError: action.personPostListError
      }
    default:
      return state;
  }
};


